import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Box from '@mui/material/Box';

import { FlightStatus_flight$key } from '__generated__/FlightStatus_flight.graphql';

type Props = {
  flight: FlightStatus_flight$key;
};

const FlightStatus: FC<Props> = ({ flight }) => {
  const { expired } = useFragment(
    graphql`
      fragment FlightStatus_flight on Flight {
        expired
      }
    `,
    flight
  );

  return (
    <Box sx={{ color: expired ? 'error.main' : 'success.main' }}>
      {expired ? 'Pasibaigęs galiojimas' : 'Aktyvus'}
    </Box>
  );
};

export default FlightStatus;
